import { format } from "date-fns";

class FormatHelper {
    static dateHandler({ date, format: formatOptions }) {
        let isValid = !isNaN(Date.parse(date));
        return isValid ? format(new Date(date), formatOptions) : "NA";
    }

    static limitNumber(number, limit){

        let value = parseInt(number);

        if(!isNaN(value)){
            value = value <= limit ? value : limit;
        }

        return value;
    }

    static uniqueArray(array){
        if(typeof array == "object" && array?.length > 0){
            array = array.filter((v, i, a) => v ? true : false) || [];
            array = array.filter((v, i, a) => a.indexOf(v) === i) || [];
        }

        return array;
    }
}

export default FormatHelper;